export const handleInputAliasChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setAliasFormResult: React.Dispatch<React.SetStateAction<string>>
) => {
  setAliasFormResult(event.target.value);
};

export const handleInputNameChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setNameForm: React.Dispatch<React.SetStateAction<string>>
) => {
  setNameForm(event.target.value);
};

export const handleInputTabChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setTabIdForm: React.Dispatch<React.SetStateAction<string>>
) => {
  setTabIdForm(event.target.value);
};

export const handleInputItemIdChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setItemId: React.Dispatch<React.SetStateAction<string>>
) => {
  setItemId(event.target.value);
};

export const handleInputSkillChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setSkillIdForm: React.Dispatch<React.SetStateAction<string>>
) => {
  setSkillIdForm(event.target.value);
};

export const handleInputChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setSearch: React.Dispatch<React.SetStateAction<string>>
) => {
  setSearch(event.target.value);
};

export const handleInputIdChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setFormId: React.Dispatch<React.SetStateAction<string>>
) => {
  setFormId(event.target.value);
};
